import { useState } from "react";
import { QuizTypeSelectionScreen } from "./QuizTypeSelectionScreen";
import { QuizScreen } from "./QuizScreen";
import { CodingQuizScreen } from "./CodingQuizScreen";

/**
 * QuizManagerScreen - Manages quiz type selection and routing
 * Allows users to choose between multiple choice quiz and coding challenges
 */
export const QuizManagerScreen = ({ courseId = "python", userName, onNavigateToAccessibility, onNext, onBack }) => {
    const [quizType, setQuizType] = useState(null);

    const handleSelectQuizType = (type) => {
        setQuizType(type);
    };

    const handleBackToSelection = () => {
        setQuizType(null);
    };

    // Show quiz type selection if no type is selected
    if (!quizType) {
        return (
            <QuizTypeSelectionScreen
                courseId={courseId}
                onSelectQuizType={handleSelectQuizType}
                onBack={onBack}
            />
        );
    }

    // Show the appropriate quiz based on selection
    if (quizType === "selection") {
        return (
            <QuizScreen
                courseId={courseId}
                userName={userName}
                onNavigateToAccessibility={onNavigateToAccessibility}
                onNext={onNext}
                onBack={handleBackToSelection}
            />
        );
    }

    if (quizType === "coding") {
        return (
            <CodingQuizScreen
                courseId={courseId}
                userName={userName}
                onNavigateToAccessibility={onNavigateToAccessibility}
                onNext={onNext}
                onBack={handleBackToSelection}
            />
        );
    }

    return null;
};
